/**
 * Service status constants
 * @type {Object}
 */
const serviceAuthorizationStatus = Object.freeze({
  PENDING: 'pending',
  APPROVED: 'approved',
  DEFERRED: 'deferred',
  DECLINED: 'declined',
  ARCHIVED: 'archived',
  DEFERRED_LOCKED: 'deferredLocked',
});

export { serviceAuthorizationStatus };
